/* "w-1/5 flex-none h-full hidden medium:block " */
.navbarPadder {
	width: 250px;
	flex: none;
	height: 100%;
	transition-duration: var(--transitionSpeed);
	translate: 0%;
	pointer-events: none;
}
.routes {
	width: 100%;
	min-height: 100vh;
	transition-duration: var(--transitionSpeed);
	display: grid;
	place-items: center;
}

/* for screens under 900px */
@media screen and (max-width: 900px) {
	.navbarPadder {
		translate: -150%;
	}
	.routes {
		position: absolute;
		height: 100vh;
	}
}
